module.exports = __webpack_public_path__ + "img/liugey2.83bfe8b9.png";